import moment from 'moment';
import React from 'react';

import { DEFAULT_DATE_TIME_A_FORMAT } from '@/src/config';

import { EmailFileEntry } from '../../../../types';

type FileItemProps = {
  file: EmailFileEntry;
  dateFormat?: string;
};

const FileItem = ({ file, dateFormat = DEFAULT_DATE_TIME_A_FORMAT }: FileItemProps) => {
  const createdDateLabel = moment(file.date).format(dateFormat);
  const fullName = `${file.file.user.fullName}`;
  return (
    <tr className="tr-divider">
      <td width={'30'}>
        <i className="material-icons" style={{ color: '#414A4F' }}>
          description
        </i>
      </td>
      <td>
        <p className="p-text">
          <strong>{file.file.name}</strong>
        </p>
        <p className="p-text">
          Uploaded by {fullName} on {createdDateLabel}
        </p>
      </td>
    </tr>
  );
};

export default FileItem;
